import { useState } from "react";
import Modal from "../../atom/modal";
import ComponentMap from "../../atom/componentmap";
import DragDrop from "../../atom/draganddropfile";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import DragAndDropFileUpload from "../../atom/updated_Fileuploader";
import FadeIn from "react-fade-in";
import Notification from "../../atom/Notification";
// import ImportNumbersModal from "./importNumbersModal";
import Loader from "../loader";
import { uploadDidFile, uploadScrubFile } from "../../services/api";
import axios from "axios";
import { getENVData } from "../../config/environment";

function ImportDIDModal(props: any) {
  const { modal, setModal, get_All_Lists, setImportDidModal } = props;
  const [loader, setLoader] = useState<boolean>(false);
  const [importModal, setImportModal] = useState<boolean>(false);
  const [fileData, setFileData] = useState<any>([]);
  const [fileId, setFileId] = useState("");
  const [fileSize, setFileSize] = useState(0);

  const [listname, setListName] = useState<any>([
    { title: "List Name", name: "listname", value: "" },
  ]);

  const onClickImport = async () => {
    if (fileData === null || fileData?.length === 0) {
      Notification("Required", "File is missing", "danger");
    } else {
      setLoader(true);
      uploadDidFile(fileData)
        .then(async (result: any) => {
          if (!result?.success) {
            let msg = result?.message;
            Notification(
              "Failed",
              msg?.charAt(0).toUpperCase() + msg.slice(1),
              "danger"
            );
            setLoader(false);
            setFileData([]);
            setFileId("");
            setFileSize(0);
          } else {
            console.log("inside if");
            setLoader(false);
            setImportDidModal(false);
            setImportModal(false);
            Notification("Success", "DIDs imported successfully", "success");
            if (result.data.csv_path) {
              setFileId(result.data.uuid);
              setFileSize(result.data.total_lines);
              setFileData(result.data.first_8_lines);
              setTimeout(() => {
                setLoader(false);
                setImportModal(false);
              }, 200);
              console.log("inside if");

              // } catch (error) {}
            }
            console.log("not inside if");
          }
        })
        .catch((error: any) => {
          console.log("error", error);
          setLoader(false);
          setFileData([]);
          setFileId("");
          setFileSize(0);
        });
    }
  };
  const handleTemplate = () => {
    const rows = [
      ["DID", "Carrier", "Sil Tenant ID"], // header
      ["1111111111", "Bandwidth", "102500163"],
      ["2222222222", "Bandwidth", "100703480"],
      ["3333333333", "Bandwidth", "102500153"],
      ["4444444444", "Bandwidth", "102500154"],
    ];

    // Convert to CSV format
    const csvContent =
      "data:text/csv;charset=utf-8," +
      rows.map((row) => row.join(",")).join("\n");

    // Create a link and trigger download
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Modal
        title={"Import DIDs"}
        closeEvent={
          // importModal || !loader ? () => setImportDidModal(false) : null
          () => setImportDidModal(false)
        }
      >
        <div
          className={`${
            importModal
              ? " w-[calc(100vw-200px)] "
              : loader
              ? "w-[400px]"
              : "w-[500px]"
          } transition-all duration-500`}
        >
          {importModal ? (
            <div></div>
          ) : loader ? (
            <div className="pt-8">
              <Loader />
              <div className="text-center my-3 text-xl">
                Uploading, please wait
              </div>
            </div>
          ) : (
            <FadeIn>
              <div>
                <div className="p-2 ">
                  <DragAndDropFileUpload
                    fileData={fileData}
                    setFileData={setFileData}
                  />
                </div>
                <div
                  className="cursor-pointer text-[#1256FE] px-2"
                  onClick={handleTemplate}
                >
                  Download Template
                </div>
                <div className="float-right pt-12 pb-4">
                  <ThemedButton
                    children={"Cancel"}
                    theme="secondary"
                    click={() => setImportDidModal(false)}
                  />
                  <ThemedButton
                    children={"Import DIDs"}
                    theme="primary"
                    // loading={}
                    click={onClickImport}
                  />
                </div>
              </div>
            </FadeIn>
          )}
        </div>
      </Modal>
    </div>
  );
}
export default ImportDIDModal;
